export default __webpack_public_path__ + "static/media/1.748db155.jpg";